<template>
    <div class="EQPage_content">
      <div class="EQPage_content_head">
        <div class="EQPage_head_img">
          <img :src="EQPageImg" @error="changeToDefaultImg(1)" />
        </div>
      </div>
      <div class="EQPage_content_body">
        <div class="EQPage_content_body_title" >{{topicOrCourseName}}</div>
        <div class="EQPage_content_body_host">
          <img class="EQPage_content_body_img" :src="userPhoto" @error="changeToDefaultImg(2)" alt="">
          <span class="EQPage_content_body_hostName">{{hostName}}</span>
        </div>
        <div v-if="type === 'topic'" class="EQPage_content_body_topic">
          <div class="EQPage_content_body_topic_time">
            <span>会议时间：</span>
            <span>{{topicData.startDateStr}}</span>
          </div>
          <div class="EQPage_content_body_topic_useTime">
            <span>预计用时：</span>
            <span>{{topicData.timeCount}}小时</span>
          </div>
        </div>
        <div v-else class="EQPage_content_body_course">
          <div class="EQPage_content_body_course_time">
            <span class="text_left">课程时间：</span>
            <span class="text_right">{{courseData.courseTimeStr}}</span>
            <div class="clear"></div>
          </div>
          <div class="EQPage_content_body_course_detail">
            <span class="text_left">课程简介：</span>
            <span class="text_right" style="overflow-y: auto;  height: 90%;">{{courseData.remark}}</span>
            <div class="clear"></div>
          </div>
        </div>
      </div>
      <div v-if="isShowFoot" class="EQPage_content_foot">
        <div class="EQPage_content_foot_main">
          <div class="EQPage_content_foot_status">{{tipValue}}</div>
          <div v-if="isShowCountDown" class="EQPage_content_foot_countdown">
            <countdown :secTime="secTime"></countdown>
          </div>
          <div @click="clickBotton" class="EQPage_content_foot_button">{{buttonValue}}</div>
        </div>
      </div>
      <pops :show="isShowVideoList" :title="'回放视频列表'" @closePop="closePop" :width="'90%'">
          <div v-if="videoList.length>0" class="videoList_main" >
            <div v-for="(item,index) in videoList " @click="videoClick(item)" class="videoList_button" :key="item.url">Video{{index+1}}</div>
          </div>
          <div v-else class="videoList_main">
            暂无视频
          </div>
      </pops>
    </div>
</template>
<style scoped>
  .EQPage_content{
    height: 100%;
    color: #333333;
    min-height: 550px;
    /* min-width: 420px; */
  }
  .EQPage_content_head{
    height: 25%;
  }
  .EQPage_head_img,.EQPage_head_img img{
    width: 100%;
    height: 100%;
  }
  .EQPage_content_body{
    height: 40%;
    box-sizing: border-box;
    padding: 15pt 15pt 0 15pt;
  }
  .EQPage_content_body_title{
    font-size: 20pt;
    font-weight: bold;
    padding-bottom: 15pt;

  }
  .EQPage_content_body_img{
    width: 24pt;
    height: 24pt;
    margin-right: 11pt;
  }
  .EQPage_content_body_host{
    display: table;
    margin-bottom: 15pt;
  }
  .EQPage_content_body_hostName{
    display: table-cell;
    vertical-align: middle;
    font-size: 14pt;
  }
  .EQPage_content_body_topic div{
    font-size: 14pt;
    /* display: inline-block; */
  }
  .EQPage_content_body_topic_time{
    margin-bottom: 15pt;
    /* float: left;
    width: 63%; */
  }
  .EQPage_content_body_topic_useTime{
    /* float: right;
    width: 37%;
    text-align: right; */
    color: #999999;
  }
  .EQPage_content_body_course{
    font-size: 14pt;
    height: calc(100% - 100px);
  }
  .EQPage_content_body_course_time{
    margin-bottom: 15pt;
  }
  .EQPage_content_body_course_detail{
    height: calc(100% - 38px);
  }
  .text_left{
    float: left;
    width: 25%;
    min-width: 96px;
  }
  .text_right{
    float: right;
    width: 65%;
  }
  .EQPage_content_foot{
    height: 35%;
    box-sizing: border-box;
    padding-top: 25pt;
  }
  .EQPage_content_foot_main{
    width: 80%;
    text-align: center;
    /* padding-top: 15pt; */
    margin: auto;
  }
  .EQPage_content_foot_status{
    font-size: 16pt;
    margin-bottom: 19pt;
  }
  .EQPage_content_foot_countdown{
    font-size: 25pt;
    color: #F5AF01;
    margin-bottom: 35pt;
  }
  .EQPage_content_foot_button{
    width: 90%;
    height: 45pt;
    line-height: 45pt;
    text-align: center;
    display: inline-block;
    color: #fff;
    background: #4EC2C2;
    font-size: 18pt;
    border-radius: 20pt;
    cursor: pointer;
  }
  .EQPage_content_foot_button:hover{
    background:#409eff
  }
  .clear{ clear:both}
  .videoList_main{
    font-size: 14pt;
    text-align: center;
    margin: 10pt;
  }
  .videoList_button{
    height: 35pt;
    line-height: 35pt;
    background: #00abad;
    margin-bottom: 15pt;
    color: #fff;
    cursor: pointer;
  }
  .videoList_button:hover{
    background:#409eff;
  }
</style>

<script>
import * as _ from '@/common/js/config'
import http from '@/api/http'
import {message} from '@/common/js/messages'
import countdown from '@/components/common/base/countdown'
import pops from '@/components/common/pops/pop'
import defalutEQImg from "@/assets/images/default.png";
import defalutUserImg from "@/assets/images/user.png";
export default {
  components:{
    countdown,
    pops
  },
  data() {
    return {
      id:"",
      type:"",
      topicData:{},//会议数据
      courseData:{},//课程数据
      tipValue:"",//提示语
      EQPageImg:"",
      userPhoto:"",//用户头像
      secTime:0,//倒计时剩余时间戳
      topicOrCourseName:"",
      hostName:"",
      buttonValue:"",
      isShowCountDown:false,
      buttonUrl:"/",//按钮点击跳转url
      isShowFoot:true,//课程自主学习不显示
      isShowVideoList:false,//是否显示回访视频列表
      videoList:[],
    }
  },
  created() {
    this.id =  this.$route.query.Id;
    this.type =  this.$route.query.type;
    this.getDetail();
  },
  methods: {
    changeToDefaultImg(type){
      if(type === 1 ){
        this.EQPageImg = defalutEQImg;
      }else{
        this.userPhoto = defalutUserImg;
      }
    },
    videoClick(item){
      const {id,url,playurl} = item;
      window.location.href = playurl;
    },
    closePop(){
      this.isShowVideoList=false;
    },
    clickBotton(){
      //查看回放可能有多个所以显示列表选择
      if(this.buttonValue === "查看回放"){
        this.getVideoList();

      }else{
        window.location.href = this.buttonUrl;
      }
    },
    getVideoList(){
      const sendData = {
        Id:this.id,
        type:this.type
      }
      http.post('/video/getCourseVideoList.json', sendData).then(res => {
        if (res.data.code === _.ERR_OK) {
            this.videoList = res.data.model;
            this.isShowVideoList=true;
        }else {
          message(res.data.msg, false)
        }
      }).catch(e=>{
          message("网络错误"+e, false)
      })
    },
    getDetail(){
      const sendData = {
        Id:this.id,
        type:this.type
      }
      http.post('/video/getCourseOrConfDetailNoSession.json', sendData).then(res => {
        if (res.data.code === _.ERR_OK) {
          const data = res.data.model;
          const nowTime = (new Date()).getTime();
          if(this.type === "topic"){
            //status 会议状态（0-未开始 1-结束 3-进行中 9-保存待发）
            const {status,startDate,startDateStr,confId,confName,timeCount,confChairName,photoUrl} = data;

            if(status === 0){
              this.tipValue = `距离会议开始`
              this.buttonValue="加入会议"
              this.secTime =Math.ceil((startDate -  nowTime )/1000);
              this.isShowCountDown = true;
            }else if(status === 1){
              this.tipValue = `会议已结束`
              this.buttonValue="查看回放"
            }else if(status === 3){
              this.tipValue = `会议正在进行中`
              this.buttonValue="加入会议"
            }
            if(photoUrl){
              this.userPhoto = photoUrl;
            }
            this.topicOrCourseName = confName;
            this.hostName = confChairName;
            this.topicData ={startDateStr,timeCount};
            this.buttonUrl = confId;
          }else if(this.type === "course"){
            //courseState 课程状态1保存 2未开始 3进行中 4已结束  自主学习 0 保存
            //teachType 1 直播课程  2 自主学习（不显示tipValue）
            const {courseState,courseTime,courseTimeStr,confId,courseImg,teachType,photoUrl,subject,teacherName,remark} = data;
            if(courseImg){
              this.EQPageImg = courseImg;
            }
            if(courseState == 0 ||courseState == 1 || courseState == 2){
              this.tipValue = `距离课程开始`
              this.buttonValue="进入课程"
              this.secTime =Math.ceil((courseTime -  nowTime )/1000);
              this.isShowCountDown = true;
            }else if(courseState == 4){
              this.tipValue = `课程已结束`
              this.buttonValue="查看回放"
            }else if(courseState == 3){
              this.tipValue = `课程正在进行中`
              this.buttonValue="进入课程"
            }
            //自主学习（不显示tipValue）
            if(teachType == 2){
              this.isShowFoot =false;
            }
            if(photoUrl){
              this.userPhoto = photoUrl;
            }
            this.topicOrCourseName = subject;
            this.hostName = teacherName;
            this.courseData={courseTimeStr,remark}
            this.buttonUrl = confId;
          }
        } else {
          message(res.data.msg, false)
        }
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// EQPage.vue?60c5258b